import React from 'react';
import './SelectTag.scss';

export interface Props {
    data?: any;
    onClick?: (data:any) => void;
    className?: string;
    key?: string | number;
    color?: "info" | "danger" | "success" | "primary" | "default" | "warn";
}

export const SelectTag: React.FC<Props> = (props) => {

    const { children, className, data, color, onClick, ...otherProps } = props;

    const handleClick = () => {
        if (onClick) {
            onClick(data);
        }
    }
    
    const css = `tag label label-${color || 'info'} ${className || ''}`;

    return (
        <span className={css} onClick={handleClick} {...otherProps}>
            <span>{children}</span>
            <button type="button">
                <i className="remove glyphicon glyphicon-remove-sign glyphicon-white"></i>
            </button> 
        </span>
    )
}

(SelectTag as any).displayName = "SelectTag";
export default SelectTag;